import { Box, Stack, Typography } from '@mui/material';

import ToolIcon from '@/components/Icons/ToolIcon';
import Actions from '@/sections/Training/Actions';
import { getTrainingJobElapsedTime, mapTrainingJobStatusToChip } from '@/sections/Training/utils';
import { ColorScale } from '@/theme/colors';

import { CardNameContainer, IconContainer, ModelData, StatusContainer } from '../../styled';
import { CardProps } from './types';

function Card({ trainingJob }: CardProps) {
  return (
    <ModelData>
      <Stack gap={1.5} pt={2} pb={2.5} pl={2.5} pr={2} flex={1}>
        <Stack spacing={0.5}>
          <Stack direction="row" justifyContent="space-between">
            <CardNameContainer>
              <IconContainer>
                <ToolIcon
                  sx={{
                    color: ColorScale.green[600],
                  }}
                />
              </IconContainer>
              <Typography variant="h4" noWrap>
                {trainingJob.name}
              </Typography>
              <Typography variant="h6" color="text.subtle">
                {trainingJob.id}
              </Typography>
            </CardNameContainer>
            <Actions trainingJob={trainingJob} variant="minimal" />
          </Stack>
        </Stack>
      </Stack>
      <Box p={2} pt={0}>
        <Typography variant="h6" noWrap>
          Project: {trainingJob.project.name}
        </Typography>
      </Box>
      <StatusContainer>
        {mapTrainingJobStatusToChip(trainingJob.status.value)}
        <Typography color="text.muted" variant="body2">
          {getTrainingJobElapsedTime(trainingJob)}
        </Typography>
      </StatusContainer>
    </ModelData>
  );
}

export default Card;
